import axios from 'axios';
import { Platform, type AxiosStatic } from '@aviata/platform-client';
import { appLocale } from 'shared';
import { freedomAuth, FlowType } from 'freedom-shared';
import { debugEntity } from '@freedom/debug-bar';

import { appConfig } from '@/shared/config';

function createLogonHttp() {
  const logonPfm = Platform(
    axios as AxiosStatic,
    {
      baseURL: appConfig.pfm.baseUrl,
      headers: {
        'x-site-url': window.location.origin,
        'accept-language': appLocale.lib.getAppLocale(),
      },
      consumer: {
        name: import.meta.env.VITE_PFM_LOGON_CONSUMER_NAME,
        key: import.meta.env.VITE_PFM_LOGON_CONSUMER_KEY,
      },
      timeout: 120000,
    },
    {},
  );

  return logonPfm.client;
}

const getInitStrategy = (shouldTryRefresh: boolean) => {
  if (import.meta.env.VITE_RUNTIME_ENV === 'production') {
    return freedomAuth.model.initFreedomAuthStrategy(
      FlowType.AVIA,
      false,
      shouldTryRefresh,
    );
  }

  const debugState = debugEntity.model.useDebugState();
  return freedomAuth.model.initFreedomAuthStrategy(
    FlowType.AVIA,
    debugState.state.value.isDevAuth,
    shouldTryRefresh,
    createLogonHttp(),
  );
};

export const apiClientLib = { getInitStrategy };
